import React from "react";

export interface StatsChartProps {
    icon?: React.ElementType;
    title: string;
    subtitle?: string;
    badge?: {
        text: string;
        color?: string;
    };
    children: React.ReactNode;
    onClick?: () => void;
    className?: string
}

function StatsChart(props: StatsChartProps) {
    return (
        <section className={`pn-chart__card ${props.className}`} onClick={props.onClick}>
            <div className="pn-chart__card__header">
                {props.icon && <span className={"pn-chart__card__icon-wrapper"}>
                    <props.icon size={14} className={"pn-chart__card__icon"}/></span>}
                <h5 className="pn-chart__card__title">
                    {props.title}
                    {props.subtitle && <p className="pn-chart__card__subtitle">{props.subtitle}</p>}
                </h5>
                {props.badge &&
                <span className={`pn-chart__card__badge ${props.badge.color}`}>{props.badge.text}</span>}
            </div>

            <div className="pn-chart__area">
                {props.children}
            </div>
        </section>
    )
}

export default StatsChart;
